import { SunMedium } from 'lucide-react';
import { APP_NAME } from '../../config/brand';

export default function AppLogo({
  withWordmark = true,
  wordmarkClassName = '',
  captionClassName = '',
  iconClassName = '',
  compact = false,
}) {
  return (
    <div className="flex items-center gap-3">
      <div
        className={`relative flex h-11 w-11 items-center justify-center overflow-hidden rounded-2xl border border-primary-200/70 bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 shadow-lg shadow-primary-900/15 ${iconClassName}`}
      >
        <span className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(214,164,65,0.35),transparent_45%)]" />
        <SunMedium className="relative z-10 h-5 w-5 text-white" strokeWidth={1.9} />
      </div>
      {withWordmark && (
        <div className={compact ? 'leading-tight' : 'space-y-0.5'}>
          <span className={`font-display text-xl font-bold tracking-tight text-[var(--ui-text)] ${wordmarkClassName}`}>
            {APP_NAME}
          </span>
          {!compact && (
            <p className={`text-xs font-medium uppercase tracking-[0.24em] text-[var(--ui-text-muted)] ${captionClassName}`}>
              Crowdfunding Togo
            </p>
          )}
        </div>
      )}
    </div>
  );
}
